import citifirst from "./citifirst.png";
import goldlogo from "./goldlogo.png";

const IMGS = {
  citifirst: citifirst,
  goldlogo: goldlogo
};

export default IMGS;